<!--<head>
  <style>
    @page {
      size: 21cm 14.8cm;
      margin: 0.54cm 2cm 0.54cm 2cm;
    }
  </style>
</head>-->
<div class="pageA5">
  <printheaderview [hasimage]="1"></printheaderview>
  <div class="row" *ngFor="let l of CurrentBillItemsByChargeEntryCodeController">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-11 text-align-center">
              <label class="margin-bottom-10px font-familyhead font-size-19px">Advance Receipt</label>
            </div>
          </div>

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.PatientName}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.PatientCode}}</label>
                  </div>
                </div>

              </div>

              <div class="col-print-6 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.ReceiptDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BillNo}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Branch}}</label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <!--<div class="col-print-11">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero width-50-new">

                      <tr>
                        <th class="font-weight-normal padding-right-0px font-family td-padding-tb background-primary padding-top-2px padding-bottom-2px">
                          S.NO
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Item Description
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Prescriber
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Qty
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Price
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Amount
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Discount
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Tax
                        </th>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Net
                        </th>
                      </tr>



                      <tr>
                        <td class="font-family padding-right-0px padding-top-2px padding-bottom-2px font-weight-normal">1</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">ANTI-MULLERIAN HARMONE(AMH)</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">
                          Dr.DOCT-91
                        </td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">
                          1
                        </td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">0</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">0</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                      </tr>
                      <tr>
                        <td class="font-family padding-right-0px font-weight-normal padding-top-2px padding-bottom-2px">2</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">ANTIPHOSPHOLIPID ANTIBODIES (APLA)</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">
                          Dr.DOCT-91
                        </td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">
                          1
                        </td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">7,440.00</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">7,440.00</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">0</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">0</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">7,440.00</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>-->

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal padding-right-10px">Received From </label>
              <label class="margin-bottom-0px font-family float-left font-weight-bold border-bot-1px">{{l.PatientName}},</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px"> the amount of INR: </label>
              <label class="margin-bottom-0px font-family float-left font-weight-bold border-bot-1px">10000,</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px">as</label>
              <label class="margin-bottom-0px font-family float-left font-weight-bold border-bot-1px"> OP Advance </label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px">, giving him/her</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal">this receipt for the same.</label>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-bold padding-right-10px">Total amount in words:</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal">(Rupees Two Thousand Only)</label>

            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-family font-weight-normal">Payment Details:</label>
              </div>

            </div>
          </div>

          <div class="col-print-11">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero width-50-new">

                      <tr>
                        <th class="font-weight-normal padding-right-0px font-family td-padding-tb background-primary padding-top-2px padding-bottom-2px">
                          S.NO
                        </th>

                        <th class="font-weight-normal padding-left-0px td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Rec.No & Date
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Pay Mode
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Paid Amount
                        </th>
                      </tr>

                      <tr>
                        <td class="font-family padding-right-0px font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                        <td class="font-family padding-left-0px font-weight-normal padding-top-2px padding-bottom-2px">HL2-HL-REC17005423 & 28-Oct-2019</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Cash</td>

                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                      </tr>


                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-7">

              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Total Paid:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">2500</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <printopbillfooterview></printopbillfooterview>

</div>

